import { z } from "zod";

import { PublicIdCategoryFilterKey } from "./-constants";

export const OrderBy = {
  NATIONAL_ID_TYPE: "NATIONAL_ID_TYPE",
  PERSON_NAME: "PERSON_NAME",
  ISSUE_DATE: "ISSUE_DATE",
  EXPIRY_DATE: "EXPIRY_DATE",
} as const;

export const NationalIdType = {
  MY_NUMBER: "MY_NUMBER",
  NATIONAL_REGISTRATION_IDENTITY_CARD: "NATIONAL_REGISTRATION_IDENTITY_CARD",
} as const;

export const SearchSchema = z.object({
  sortOrder: z.enum(["asc", "desc"]).default("asc").optional(),
  sortColumn: z
    .union([
      z.nativeEnum(OrderBy),
      z.enum(["nationalIdType", "person", "issueDate", "expiryDate"]),
    ])
    .optional(),
  nationalIdType: z.array(z.nativeEnum(NationalIdType)).optional(),
  freeText: z.string().optional(),
  page: z.number().default(1),
  pageSize: z.number().default(100),
  publicIdType: z
    .nativeEnum(PublicIdCategoryFilterKey)
    .default(PublicIdCategoryFilterKey.NATIONAL_ID)
    .catch(PublicIdCategoryFilterKey.NATIONAL_ID),
});
